import React from 'react'
import PropTypes from 'prop-types'
import { compose, withState } from 'recompose'
import styled, { css } from 'styled-components'
import { theme } from 'styled-tools'
import BookingDetails from '../booking-details/BookingDetails'
import ArrowDownIcon from '../icons/arrow-down'
import CalendarIcon from '../icons/calendarIcon'
import useTranslation from '../../../utils/translation'

const StyledPrepBookingContainer = styled.div`
  color: ${theme('forms.prepForm.bookingCompleteMsg.color')};
  background: ${theme('forms.prepForm.bookingCompleteMsg.background')};
  border-radius: 3px;
  padding: 12px 13px 15px 13px;
  margin-top: 15px;

  ${(props) => props.theme.media.min.sm`
    padding: 22px 23px 27px 23px;
  `}
`

const StyledContainerTop = styled.div`
  display: flex;
  justify-content: space-between;
  svg {
    fill: ${theme('forms.prepForm.bookingCompleteMsg.background')};
    width: 32px;
    height: 32px;
    margin-right: 12px;
    flex-shrink: 0;
  }
  ${(props) => props.theme.media.min.sm`
    svg {
      width: 49px;
      height: 49px;
      margin-right: 15px;
    }
  `}
`
const StyledContentLeft = styled.div`
  display: flex;
  align-items: center;
`

const StyledPrepBookingCompleteContent = styled.div``

const StyledContentRight = styled.div`
  display: flex;
  align-items: center;
  svg {
    width: 21px;
    height: 21px;
    margin-right: 0px;
  }
`

const StyledPrepBookingCompleteHeading = styled.h5`
  font-size: 16px;
  font-weight: 500;
  font-family: ${theme(
    'forms.prepForm.bookingCompleteMsg.typography.heading.fontFamily'
  )};
  line-height: 22px;
  margin-block-start: 0em;
  margin-block-end: 0em;
  ${(props) => props.theme.media.min.sm`
    font-size: 18px;
    line-height: 24px;
  `}
`

const StyledPrepBookingCompleteParagraph = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin-block-start: 0em;
  margin-block-end: 0em;
  display: none;
  ${(props) => props.theme.media.min.sm`
      display: block;
  `}
`

const DetailsToggleButton = styled.button`
  text-decoration: underline;
  position: relative;
  color: #fff;
  border: 0;
  background: transparent;
  font-weight: ${theme('forms.prepForm.detailsToggleButton.fontWeight')};
  cursor: pointer;
  svg {
    transition: transform cubic-bezier(0.68, -0.55, 0.265, 1.55) 0.3s;
  }
  ${(props) =>
    props.active &&
    css`
      svg {
        transform: rotate(180deg);
      }
    `}
`
const StyledBookingDetailsContainer = styled.div`
  margin-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  line-height: 24px;
  h3 {
    color: #ffffff;
    font-family: ${theme('typography.paragraph.fontFamily')};
  }
  a {
    color: #ffffff;
  }
  div {
    padding-left: 0px;
    padding-right: 0px;
    margin-left: 0px;
    margin-right: 0px;
    margin-bottom: 0px;
    div {
      img {
        display: none;
      }
    }
    div:not(:first-of-type) {
      margin-right: 20px;
    }
  }
`

const PrepBookingComplete = ({
  selectedStore,
  selectedSlot,
  content,
  detailsActive,
  toggleDetails,
  returningVisitor,
}) => {
  if (!content) return null

  const t = useTranslation('app.prep-form')

  return (
    <>
      {!returningVisitor && (
        <StyledPrepBookingContainer>
          <StyledContainerTop>
            <StyledContentLeft>
              <CalendarIcon />
              <StyledPrepBookingCompleteContent>
                <StyledPrepBookingCompleteHeading>
                  {(content.preparationBookingCompleteHeading &&
                    content.preparationBookingCompleteHeading) ||
                    t('booking-completed-heading')}
                </StyledPrepBookingCompleteHeading>
                <StyledPrepBookingCompleteParagraph>
                  {(content.preparationBookingCompleteSubheading &&
                    content.preparationBookingCompleteSubheading) ||
                    t('booking-completed-text')}
                </StyledPrepBookingCompleteParagraph>
              </StyledPrepBookingCompleteContent>
            </StyledContentLeft>
            <StyledContentRight>
              <DetailsToggleButton
                data-cy="booking-summary-button"
                onClick={() => toggleDetails(!detailsActive)}
                active={detailsActive}
              >
                <ArrowDownIcon width={10} height={10} />
              </DetailsToggleButton>
            </StyledContentRight>
          </StyledContainerTop>
          {detailsActive && (
            <StyledBookingDetailsContainer>
              <BookingDetails
                detailsActive={detailsActive}
                selectedStore={selectedStore}
                selectedSlot={selectedSlot}
                selectedServiceName={
                  content.preparationBookingCompleteMeetingTypeDescription ||
                  content.heading
                }
              />
            </StyledBookingDetailsContainer>
          )}
        </StyledPrepBookingContainer>
      )}
    </>
  )
}

PrepBookingComplete.propTypes = {
  selectedStore: PropTypes.shape(),
  selectedSlot: PropTypes.shape(),
  content: PropTypes.shape(),
  detailsActive: PropTypes.bool.isRequired,
  toggleDetails: PropTypes.func.isRequired,
  returningVisitor: PropTypes.bool,
}

PrepBookingComplete.defaultProps = {
  selectedStore: {},
  selectedSlot: {},
  content: {},
  returningVisitor: false,
}

const enhance = compose(withState('detailsActive', 'toggleDetails', false))

export default enhance(PrepBookingComplete)
